var _defs, _path, _polyline, _polyline2, _line, _polyline3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarquise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.39,5.3s4.1,3.84,8.07,8.51,8.64,10.67,10.67,14.99,7.58,13.85,7.41,26.01c-.18,12.17-6.08,24.25-6.97,25.93s-4.59,9.79-9.79,15.26-8.47,7.94-9.44,8.64c0,0-5.47-3.97-9.61-8.55-4.14-4.59-7.5-10.23-9.79-14.64-2.29-4.41-6.35-15.7-6.53-26.59s6.7-25.53,6.88-26.24,5.82-10.32,10.67-15.61,8.42-7.72,8.42-7.72Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "64.13 13.44 56.47 24.07 62.56 31.46 71.51 41.68 82.53 54.82 71.67 66.74 63.07 76.91 52.71 88.85 36.94 81.45 41.04 67.13 44.85 54 50.14 31.63 52.99 19.55 56.39 5.3 59.86 19.91 62.67 31.9 68.29 54.54 71.78 67.13 75.56 80.75 60.19 89.43 56.39 84.68 49.88 77.11 41.04 67.13 30.41 54.87 41.1 42.22 50.14 31.63 56.47 24.07 47.96 13.02"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "52.99 19.55 37.15 29 41.1 42.22 44.7 54.53 49.88 77.11 52.71 88.85 56.34 104.65 60.19 89.43"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 46.73,
    y1: 96.09,
    x2: 52.71,
    y2: 88.85
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "65.77 96 60.19 89.43 63.07 76.91 68.29 54.54 71.51 41.68 75.01 28.57 59.73 19.55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarquise);
export default __webpack_public_path__ + "static/media/marquise.d879754219fe654c34cd0a4fc7a30f68.svg";
export { ForwardRef as ReactComponent };